import axios from "axios";

function getData(data) {
    return axios.post('api/tercero/dataTercero', data);
}

function guardarData(data) {
    return axios.post('api/tercero/guardarTercero', data);
}

function eliminarTercero(data) {
    return axios.delete(`api/tercero/${data}`);
}

function actualizarData(data) {
    return axios.post('api/tercero/actualizarTercero', data);
}

export {
    getData,
    guardarData,
    actualizarData,
    eliminarTercero
}
